import React, { FunctionComponent } from "react";
import { Popper } from "react-popper";
import { AnimatePresence } from "framer-motion";
import { BSMotionDiv } from "../../types";
import { TooltipElement } from "./TooltipElement";

export interface TooltipPopperProps extends BSMotionDiv {
  placement?: "top" | "right" | "bottom" | "left";
  visible?: boolean;
}

export const TooltipPopper: FunctionComponent<TooltipPopperProps> = ({
  placement = "top",
  visible = false,
  ...tooltipProps
}) => (
  <AnimatePresence>
    {visible && (
      <Popper placement={placement}>
        {(p) => (
          <TooltipElement {...tooltipProps} {...p} placement={placement} />
        )}
      </Popper>
    )}
  </AnimatePresence>
);
